import { ofType, ActionsObservable } from 'redux-observable';
import { map, mergeMap, flatMap, delay } from 'rxjs/operators';
import { from } from 'rxjs';
import {
    TransformCaller, TransformSelectedPatientToCaller
} from './transformCaller';
import {
    TransformPatient
} from './transformPatient';
import {
    SourceType,
    Skeleton
} from 'one-model-local';

import {
    resetAction
} from 'one-state-source-local';
import {
    Source
} from 'one-model-local';

import {
    RESET,
} from 'one-state-subject/src/types';

import {
    reinitAction as PatientVerifyRESET
} from 'one-state-patient-verify';

import {
    setAction as setSourceType,
    selectAction as selectSourceType,
} from 'one-state-source-type';
import {
    reinitAction as reinitSourceTypeAction
} from 'one-state-source-type';
import {
    setAction as setSkeletonAction
} from 'one-state-skeleton';

import {
    addAction
} from 'one-state-error/src/actions';

import {
    selectAction as sourceSelectAction,
    addAction as sourceAddAction
} from 'one-state-source-local';

import {
    ErrorObject
} from 'one-state-error/src/errorobject';
import { format } from 'one-util-date';
import { Disposition } from 'one-model-local';

export const enum Types {
    CALLERDETAILS = 'getcallerdetails',
    CONSOLIDATEDAPI = 'consolidated-api-one',
    SETCALLERDBDETAILS = 'one-state-source/set',
    SETSELECTEDCALLERDETAILS = 'one-state-source/select',
    SETPATIENTLOOKUPDETAILSTOCALLER = 'one-state-source/set',
    SETSOURCETYPETOCALLER = 'one-state-source-type/set',
    SETPATIENTDATATOCALLER = 'one-state-subject/set',
    SETONSOURCETYPECHANGE = 'one-state-source-type/select',
    STORE_DISPOSITION_CODE = "store-disposition-code",

}

const pushtoSETCallerDBPatient = (payload: any) => ({ type: Types.SETCALLERDBDETAILS, payload });
const mergePatientDataWithCaller = (payload: any) => ({ type: Types.SETPATIENTLOOKUPDETAILSTOCALLER, payload });
const patientSelectedDataToCaller = (payload: any) => ({ type: Types.SETSELECTEDCALLERDETAILS, payload });
const pushSouceTypeToCaller = (payload: any) => setSourceType(payload);
const pushSelectedSouceTypeToCaller = (payload: any) => selectSourceType(payload);
const pushToSkeleton = (payload: any) => setSkeletonAction(payload);
const pushToDisposition = (payload: any) => ({ type: Types.STORE_DISPOSITION_CODE, payload });
/**
 * This function will fetch the data of caller detials from db
 * based on the ani and selected type is patient
 * @param context constains settings json etc ..
 */

export const fetchCallerDetailsFromDB = (context: any) => (
    (action$: ActionsObservable<any>, state$: any) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            agentId,
            teamName,
            alertnotification,
            settings:
            {
                compatible,
                epicendpoints: { callerdetails, apitoken }
            }
        } = context;
        const { contact_center_type } = compatible;
        return action$.pipe(
            ofType(Types.CALLERDETAILS),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epics", "callerEpic request", dataresponse);
                const getCallerDetails = (payload: any) => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    const response = server.get({
                        //path: epicendpoints.callerdetails + "?phone_ani=" + payload.number + "&typename=" + payload.type,
                        path: callerdetails + "?phone_ani=" + payload.number,
                        headers: headers
                    }).then((responsefound: any) => responsefound)
                        .catch((responseresult: any) => {
                            log.error(
                                "ccw-gadget,caller-epic",
                                "fetch-callers-fromDB", {
                                responseresult
                            }
                            );
                            // SEND to ALERT snotificiton/NOCserver for errors
                            if (responseresult?.status === 0) {
                                if (alertnotification?.isEnabled()) {
                                    var timestamp = new Date().toJSON();
                                    alertnotification.notify({
                                        "error_code": "930-31",
                                        "error_type": "SERVER_ERROR",
                                        "error_description": "Unable to reach active servers",
                                        "error_supertype": "SERVER_FAILS",
                                        "error_detail": "Unable to reach any of server for retring data ",
                                        "alert": "Yes",
                                        "timestamp": timestamp,
                                        "params": responseresult
                                    });
                                }
                            }
                            let sourceerror: ErrorObject = {
                                source: "Source",
                                type: "error",
                                status: responseresult?.status,
                                erroritems: responseresult?.errors,
                                error_date: errorDate,
                                error_time: errorTime
                            };
                            return sourceerror;
                        })
                    log.debug("one-epics", "callerEpic response", response);
                    return from(response);
                }
                return getCallerDetails(dataresponse).pipe(
                    map(response => TransformCaller(response, context))
                ).pipe(
                    flatMap(response => {
                        const actions: any = [
                            pushtoSETCallerDBPatient(response.sourcedata)
                        ];
                        //For Source
                        const selected = response?.sourcedata?.find(
                            (item: any) => item?.id === dataresponse?.sourceid
                        );
                        if (selected && 'id' in selected) {
                            //actions.push(sourceAddAction(selected));
                            actions.push(sourceSelectAction(selected?.id));
                        }
                        //Making skeleton to false
                        let skeletonsource: Skeleton = {
                            source_skeleton: false
                        }
                        actions.push(pushToSkeleton(skeletonsource));
                        if (response.error) {
                            actions.push(addAction(response.error));
                            let disp: Disposition = { value: "998" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta00 = agentIdValue;
                                disp.meta01 = skillName;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            } else {
                                disp.meta00 = agentId;
                                disp.meta01 = teamName
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta02 = response?.error?.status;
                            disp.meta03 = response?.error?.erroritems[0]?.error_detail;
                            disp.meta04 = 'client';
                            actions.push(pushToDisposition(disp));
                        } else {
                            let disp: Disposition = { value: "194" }
                            if (contact_center_type && contact_center_type === 'five9') {
                                let agentIdValue = sessionStorage.getItem("agentName");
                                let skillName = sessionStorage.getItem("skillName");
                                disp.meta00 = agentIdValue;
                                disp.meta01 = skillName;
                                disp.dial_list_uid = state$.value.five9Interaction?.interactionId;
                            } else {
                                disp.meta00 = agentId;
                                disp.meta01 = teamName;
                                disp.dial_list_uid = state$.value.choosecaller?.callId;
                            }
                            disp.meta02 = '200';
                            disp.meta03 = 'client';
                            actions.push(pushToDisposition(disp));
                        }
                        return actions;
                    })
                )
            })
        )
    }

);

/**
 * This Fuction will set Source data if Source is a patient.
 * This is particulary when patient look up api is exected after the getcallerdetails
 * This fucntion particulary resolves the bug in the scenario of consult, transfer and conference.
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const setSourceAsItIsSubject = (context: any) => (
    (action$: any, state$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget,setSourceAsItIsSubject",
            "setSourceAsItIsSubject", {
        });
        return action$.pipe(
            ofType(Types.CALLERDETAILS,Types.CONSOLIDATEDAPI),
            delay(3000),
            // map(action => reinitSourceTypeAction())
            flatMap((action: any) => {
                const actions: any = [];
                const dataresponse: any = action.payload;
                log.debug("one-epics", "setSourceAsItIsSubject request", dataresponse);
                const data: Source[] = state$.value.sources?.values;
                //For Source
                const selected = data?.find(
                    (item: any) => item?.id === dataresponse?.sourceid);
                if (selected && 'id' in selected) {
                    //actions.push(sourceAddAction(selected));
                    actions.push(sourceSelectAction(selected?.id));
                }   
                
                
                return actions;
            })
        )
    }
);

export const pushSelectedPatientDataToCaller = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log
        } = context;
        return action$.pipe(
            ofType(Types.SETCALLERDBDETAILS, Types.SETPATIENTLOOKUPDETAILSTOCALLER, Types.SETONSOURCETYPECHANGE),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the request to select default patient in caller card
                 */
                var dataresponse = action.payload;
                log.debug("one-epics", "selectedCaller request", dataresponse);
                const getRequest = (datares: any) => {
                    const sourceTypeSelected: SourceType = state$.value.sourcetype?.selected;
                    const data: Source[] = state$.value.sources?.values;
                    let value: string = TransformSelectedPatientToCaller(data, context, sourceTypeSelected);
                    log.debug("one-epics", "selectedCaller response", value);
                    return from([value]);
                }

                return getRequest(dataresponse).pipe(
                    map(response => patientSelectedDataToCaller(response))
                )
            })

        )
    }
);

export const fetchSouceTypeToCaller = (context: any) => (
    (action$: any) => {
        const {
            log,
            settings:
            {
                soucetypelookup
            }
        } = context;
        return action$.pipe(
            ofType(Types.CALLERDETAILS),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contain patient type etc..
                 */
                var dataresponse = action.payload;
                log.debug("one-epics", "sourceType request", dataresponse);
                const getRequest = (datares: any) => {
                    const sourceType: SourceType[] = soucetypelookup;
                    //TODO: use map and iterate.
                    log.debug("one-epics", "sourceType response", sourceType);
                    return from([sourceType]);
                }

                return getRequest(dataresponse).pipe(
                    map(response => pushSouceTypeToCaller(response))
                )
            })

        )
    }
);

export const fetchSelectedSouceTypeToCaller = (context: any) => (
    (action$: any) => {
        const {
            log,
            settings:
            {
                soucetypelookup
            }
        } = context;
        return action$.pipe(
            ofType(Types.CALLERDETAILS),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contain patient type etc..
                 */
                var dataresponse = action.payload;
                log.debug("one-epics", "sourceType request", dataresponse);
                const getRequest = (datares: any) => {
                    let patienttype = datares.type;
                    const sourcetypeselected: SourceType = soucetypelookup?.find(
                        (item: any) => item.label === patienttype
                    );
                    //state.selected = patientselected;
                    log.debug("one-epics", "sourceType response", sourcetypeselected);
                    return from([sourcetypeselected]);
                }

                return getRequest(dataresponse).pipe(
                    map(response => pushSelectedSouceTypeToCaller(response))
                )
            })

        )
    }
);

export const pushPatientDataToCaller = (context: any) => (
    (action$: any, state$: any) => {
        const {
            log,
            settings:
            {
                soucetypelookup
            }
        } = context;
        return action$.pipe(
            ofType(Types.SETPATIENTDATATOCALLER),
            mergeMap((action: any) => {
                /**
                 * @param dataresposne contains the patientlookup response
                 */
                let dataresponse = action.payload;
                log.debug("one-epics", "MergePatientToCaller request", dataresponse);
                const getRequest = (datares: any) => {
                    let result: Source[] = TransformPatient(datares, soucetypelookup, context);
                    log.debug("one-epics", "MergePatientToCaller response", result);
                    return from([result]);
                }
                return getRequest(dataresponse).
                    pipe(
                        map(response => mergePatientDataWithCaller(response))
                    )
            })

        )
    }
);


/**
 * This Fuction will clear data of source epic
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearSourceEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget,source-epic",
            "Reset-Source-epic", {
        });
        return action$.pipe(
            ofType(RESET),
            map(action => resetAction())
        )
    }
);

/**
 * This Fuction will clear data of source type epic and PAtientVerified
 * subsequent redux action
 * @param context contains the settings,logger etc..
 */
export const clearSourceTypeEpic = (context: any) => (
    (action$: any) => {
        const { log } = context;
        log.debug(
            "ccw-gadget,source-type-epic",
            "Reset-Source-Type-epic", {
        });
        return action$.pipe(
            ofType(RESET),
            // map(action => reinitSourceTypeAction())
            flatMap(response => {
                const actions: any = [
                    reinitSourceTypeAction()
                ];
                // RESET Patient Verify
                actions.push(PatientVerifyRESET());
                return actions;
            })
        )
    }
);




